import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import ContractorPortalApi from "../../../../../../infrastructure/api/contractorPortalApi";
import { CONTRACT_UX } from "./contractUxTheme";

/**
 * In-app PDF viewer for the generated contractor master contract.
 */
const ContractPdfViewerDialog = ({
  open,
  contractId,
  contractNumber,
  onClose,
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [objectUrl, setObjectUrl] = useState(null);

  useEffect(() => {
    let revoked = false;
    let createdUrl = null;

    const load = async () => {
      if (!open || !contractId) return;
      setLoading(true);
      setError(null);
      setObjectUrl(null);

      const res = await ContractorPortalApi.downloadMasterContractPdf(contractId, {
        preferSigned: true,
      });
      if (revoked) return;

      if (!res?.isSuccess || !res.data) {
        setError(res?.message || "مشاهده قرارداد ممکن نیست.");
        setLoading(false);
        return;
      }

      const blob =
        res.data.type && res.data.type.includes("pdf")
          ? res.data
          : new Blob([res.data], { type: "application/pdf" });
      createdUrl = URL.createObjectURL(blob);
      setObjectUrl(createdUrl);
      setLoading(false);
    };

    load();

    return () => {
      revoked = true;
      if (createdUrl) URL.revokeObjectURL(createdUrl);
    };
  }, [open, contractId]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="lg"
      data-testid="contract-pdf-viewer-dialog"
    >
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1, pr: 1 }}>
        <Typography variant="subtitle1" fontWeight={800} sx={{ flex: 1 }}>
          مشاهده قرارداد
          {contractNumber ? ` — ${contractNumber}` : ""}
        </Typography>
        <IconButton onClick={onClose} aria-label="بستن" size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0, minHeight: "70vh", bgcolor: "#525659" }}>
        {loading ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="70vh"
          >
            <CircularProgress sx={{ color: "#fff" }} />
          </Box>
        ) : null}
        {!loading && error ? (
          <Box p={3} bgcolor="#fff">
            <Typography color="error">{error}</Typography>
          </Box>
        ) : null}
        {!loading && objectUrl ? (
          <Box
            component="iframe"
            title="متن قرارداد"
            src={objectUrl}
            sx={{
              width: "100%",
              height: "70vh",
              border: 0,
              bgcolor: CONTRACT_UX.bg,
            }}
          />
        ) : null}
      </DialogContent>
    </Dialog>
  );
};

export default ContractPdfViewerDialog;
